import {signOut} from "aws-amplify/auth"

export default async function logout() {
    try {
        await signOut()
        return {signOut: true}
    } catch(error) {
        console.error("logout: ", error)
    }
}